module.exports = __webpack_public_path__ + "img/icon-arrow-right-white.svg";